import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const InstagramIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.0279 6.87463C9.18664 6.87463 6.87466 9.18661 6.87466 12.0278C6.87466 14.8691 9.18664 17.181 12.0279 17.181C14.8691 17.181 17.1811 14.8691 17.1811 12.0278C17.1811 9.18661 14.8691 6.87463 12.0279 6.87463ZM12.0279 15.3705C10.1894 15.3705 8.68525 13.8663 8.68525 12.0278C8.68525 10.1894 10.1894 8.68522 12.0279 8.68522C13.8663 8.68522 15.3705 10.1894 15.3705 12.0278C15.3705 13.8663 13.8663 15.3705 12.0279 15.3705Z"
        fill={color}
      />
      <path
        d="M17.3761 5.48187C16.7075 5.48187 16.1783 6.01112 16.1783 6.67964C16.1783 7.34817 16.7075 7.87742 17.3761 7.87742C18.0446 7.87742 18.5738 7.34817 18.5738 6.67964C18.5738 6.01112 18.0446 5.48187 17.3761 5.48187Z"
        fill={color}
      />
      <path
        d="M22 7.90529C21.8329 4.25627 19.7994 2.22284 16.1504 2.05571C15.0919 2 14.7298 2 12.0279 2C9.3259 2 8.96379 2 7.90529 2.05571C4.25627 2.22284 2.22284 4.25627 2.05571 7.90529C2 8.96379 2 9.3259 2 12.0279C2 14.7298 2 15.0919 2.05571 16.1504C2.22284 19.7994 4.25627 21.805 7.87744 21.9721C8.93593 22.0279 9.29805 22.0279 12 22.0279C14.702 22.0279 15.0641 22.0279 16.1226 21.9721C19.7716 21.805 21.7772 19.7716 21.9443 16.1504C22 15.0919 22 14.7298 22 12.0279C22 9.3259 22 8.96379 21.9443 7.90529H22ZM20.1894 16.0669C20.078 18.7688 18.7967 20.0501 16.0669 20.1894C15.0084 20.2451 14.7019 20.2451 12.0279 20.2451C9.35376 20.2451 9.0195 20.2451 7.98886 20.1894C5.25905 20.078 4.00557 18.7688 3.8663 16.0669C3.81058 15.0084 3.81058 14.7019 3.81058 12.0279C3.81058 9.35376 3.81058 9.04735 3.8663 7.98886C3.97772 5.28691 5.25905 4.00557 7.98886 3.8663C9.04735 3.81058 9.35376 3.81058 12.0279 3.81058C14.7019 3.81058 15.0362 3.81058 16.0669 3.8663C18.7967 3.97772 20.0501 5.28691 20.1894 7.98886C20.2451 9.04735 20.2451 9.35376 20.2451 12.0279C20.2451 14.7019 20.2451 15.0362 20.1894 16.0669Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

InstagramIcon.displayName = 'InstagramIcon';
